const config: siteConfig = {
  API_URL: "/backend/api",
  ENCRYPTION_KEY: "your-secret-key",
  REDIRECT_SESSION_KEY: "",
  CLIENT_URL: "http://127.0.0.1:5000",
};

export default config;
